import React from 'react';
import './Breadcrumb.css';
import { Link, useLocation } from 'react-router-dom';
import home from '../../assets/banner/home-1 1.svg';
import arrow from '../../assets/banner/Group.svg';
// const Breadcrumb = ({ paths }) => {
//     return (
//         <div className="breadcrumb-container">
//             <nav className="breadcrumb">
//                 <img src={home} alt='home' />
//                 {paths.map((item, index) => (
//                     <React.Fragment key={index}>
//                         <img src={arrow} alt='arrow' />

//                         {item.href ? (
//                             <a href={item.href}>{item.label}</a>
//                         ) : (
//                             <span className="active">{item.label}</span>
//                         )}
//                         {/* {index < paths.length - 1 && <span className="divider">›</span>} */}
//                     </React.Fragment>
//                 ))}
//             </nav>
//         </div>
//     );
// };

// export default Breadcrumb;


// const Breadcrumb = ({ paths }) => {
//     const location = useLocation();
//     const currentPath = location.pathname;
//     return (
//       <div className="breadcrumb-container">
//         <nav className="breadcrumb">
//         <img src={home} alt='home' />
//           {paths.map((item, index) => (
//             <React.Fragment key={index}>
//               <img src={arrow} alt='arrow' />
//               {item.href ? (
//                 <Link to={item.href}>{item.label}</Link>
//               ) : (
//                 <span className="active">{item.label}</span>
//               )}
//             </React.Fragment>
//           ))}
//         </nav>
//       </div>
//     );
//   };
  
//   export default Breadcrumb;


// Breadcrumbs.jsx
import bannerImage from '../../assets/banner/banners.png';
const Breadcrumbs = () => {
  const location = useLocation();

  // Split pathname into parts
  const pathnames = location.pathname.split('/').filter((x) => x);

  return (
    <nav  className='breadcrumb-container'>
            {/* <img src={bannerImage} alt='banner'/> */}
<div className='breadcrumb-container-main container'>
      <Link to="/"><img src={home} alt='home'/></Link>
      <img
                src={arrow}
                alt="arrow"
                style={{ margin: '0 8px', width: '8px', height: 'auto' }}
              />
      {pathnames.map((value, index) => {
        const to = `/${pathnames.slice(0, index + 1).join('/')}`;

        // Capitalize and replace hyphens
        const label = value
          .replace(/-/g, ' ')
          .replace(/\b\w/g, (c) => c.toUpperCase());

        return (
            <span key={to} style={{ display: 'inline-flex', alignItems: 'center'}}>
            {/* Only show the arrow if it's not the first item */}
            {index > 0 && (
              <img
                src={arrow}
                alt="arrow"
                style={{ margin: '0 8px', width: '8px', height: 'auto' }}
              />
            )}
            {index === pathnames.length - 1 ? (
              <span style={{ color: '#0066CC' }}>{label}</span>
            ) : (
              <Link to={to}>{label}</Link>
            )}
          </span>
          
        );
      })}
</div>

    </nav>
  );
};

export default Breadcrumbs;
